import type { QueryClient } from '@tanstack/react-query'
import { PluggyPendenciaTipo } from '../../lib/enums'
import type { PluggyPendenciaInfo } from '../../types'

/** Só pendências "Nova" entram no "Aceitar tudo": duplicatas, transferências, faturas e estornos continuam individuais. */
export const soNovas = (lista: PluggyPendenciaInfo[]) => lista.filter((p) => p.tipo === PluggyPendenciaTipo.Nova)

export function invalidarPluggy(qc: QueryClient) {
  for (const k of ['pluggy-vinculos', 'pluggy-contas', 'pluggy-pendencias', 'pluggy-historico', 'transacoes', 'contas', 'cartoes', 'dashboard', 'onboarding']) {
    qc.invalidateQueries({ queryKey: [k] })
  }
}

/** Id da conexão (itemId) encurtado para exibir. */
export const itemAbreviado = (itemId: string) => itemId.slice(0, 8)

export interface OpcaoConexao { itemId: string; rotulo: string }
